import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  setGoogleSearchTextAction,
  googleSearchTextSelector,
  getStatementTxnSearchAction,
} from '@/domain/googleSearch';
import {
  JEGoogleSearchWrapper,
  JEGoogleSearchIconButton,
  JEGoogleSearchValue,
} from '@/components/Tables/grid/withGoogleSearch/StyledComponents';

import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

const shouldCellBeColorCoded = (data) => {
  if (data) {
    const value = data.getIn(['cellSet', 'value']);
    return value === 'Match' || value === 'NoMatchCanCrate'; // use status constants
  }
  return false;
};

const withGoogleSearch = (WrappedComponent) => {
  class WithGoogleSearch extends React.Component {
    getItem = (row, col) => {
      const { getItem, googleSearchCols, lineItems, reconcileColumn } = this.props;

      // return googleSearchCols.includes(col) && lineItems.includes(row) ? (
      return googleSearchCols.includes(col) && lineItems.includes(row) ? (
        <JEGoogleSearchWrapper
          sx={{
            ...(shouldCellBeColorCoded(this.props.data.get(`${reconcileColumn}${row}`))
              ? { backgroundColor: 'rgb(231, 245, 234)' }
              : {}),
          }}
        >
          <JEGoogleSearchIconButton onClick={this.showGooglePanel(`${col}${row}`)}>
            <LocationOnOutlinedIcon />
          </JEGoogleSearchIconButton>
          <JEGoogleSearchValue>{getItem(row, col)}</JEGoogleSearchValue>
        </JEGoogleSearchWrapper>
      ) : (
        getItem(row, col)
      );
    };

    showGooglePanel = (cell) => (e) => {
      e.preventDefault();
      e.stopPropagation();
      const data = this.props.data.get(cell);
      if (data) {
        const value = data.getIn(['cellSet', 'value']);
        this.props.getStatementTxnSearch(value);
      }
    };

    render() {
      return <WrappedComponent {...this.props} getItem={this.getItem} />;
    }
  }

  WithGoogleSearch.displayName = WrappedComponent.displayName;

  const mapStateToProps = (state) => ({
    googleSearchText: googleSearchTextSelector(state),
  });

  const mapDispatchToProps = {
    setGoogleSearchText: setGoogleSearchTextAction,
    getStatementTxnSearch: getStatementTxnSearchAction,
  };

  return compose(connect(mapStateToProps, mapDispatchToProps))(WithGoogleSearch);
};

export default withGoogleSearch;
